import { createSelector } from '@reduxjs/toolkit';
import { SELECTOR, setSelector } from '@socialive/common';
import selectSplitioRaw from './selectSplitioRaw';

const selectSplitStatus = createSelector(selectSplitioRaw, ({ isReady, isTimedout } = {}) => ({
  loading: !isReady && !isTimedout,
  complete: isReady || isTimedout,
  ready: isReady,
  timedOut: isTimedout,
}));

setSelector(SELECTOR.SPLIT_STATUS, selectSplitStatus);

export default selectSplitStatus;
